export default __webpack_public_path__ + "static/media/right_tree.8729b691.svg";